import React from "react";

const fmtAt = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");
const fmtVal = (v) => (v === null || v === undefined ? "—" : Array.isArray(v) ? v.join(", ") : typeof v === "boolean" ? String(v) : String(v));

/** Field-level audit trail of one assumption set (newest first). */
export function ValueAuditList({ items }) {
    if (!items?.length) return <div className="text-xs text-slate-500 italic" data-testid="va-audit-empty">No edits yet — the built-in defaults are in use.</div>;
    return (
        <div className="overflow-x-auto" data-testid="va-audit">
            <table className="w-full text-xs">
                <thead className="text-slate-500 text-left">
                    <tr><th className="py-1 pr-3 font-medium">When</th><th className="py-1 pr-3 font-medium">v</th><th className="py-1 pr-3 font-medium">Field</th>
                        <th className="py-1 pr-3 font-medium">Old → New</th><th className="py-1 pr-3 font-medium">Reason</th><th className="py-1 font-medium">By</th></tr>
                </thead>
                <tbody className="text-slate-300">
                    {items.map((a) => (
                        <tr key={a.audit_id} className="border-t border-slate-800/80 align-top" data-testid={`va-audit-row-${a.audit_id}`}>
                            <td className="py-1 pr-3 whitespace-nowrap text-slate-400">{fmtAt(a.at)}</td>
                            <td className="py-1 pr-3 font-mono text-slate-500">{a.version}</td>
                            <td className="py-1 pr-3 font-mono text-sky-300">{a.field}</td>
                            <td className="py-1 pr-3 font-mono"><span className="text-slate-500">{fmtVal(a.old)}</span> → <span className="text-emerald-200">{fmtVal(a.new)}</span></td>
                            <td className="py-1 pr-3 text-slate-400 max-w-[280px]">{a.reason}</td>
                            <td className="py-1 whitespace-nowrap">
                                {a.actor}
                                {a.source === "calibration" ? <span className="ml-1 rounded border border-violet-400/40 text-violet-300 px-1 text-[9px] uppercase">calibration</span> : null}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
